// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__eWq9q","error":"Error_error__e5zUP"};